<div class="inspection-page">
  <ysh-page-header
    title="Inspection Details"
    [backLinkRoute]="backLinkRoute"
    backLinkLabel="All Inspections"
  />
  <div class="grid">
    <ysh-panel
      class="grid__panel"
      heading="Overview"
      padding="left-right-bottom"
      [loading]="!order">

      @if (orderOverview) {
        <ysh-traits [traits]="orderOverview"/>
      }
    </ysh-panel>

    <ysh-panel
      class="grid__panel"
      heading="Details"
      padding="left-right-bottom"
      [loading]="!order">

      @if (order?.inspection?.isStructured) {
        <ysh-inspection-report [report]="order.inspection"/>
      }
      @else if (orderDetails) {
        <ysh-traits [traits]="orderDetails" heading="Inspection Point" labelOpacity="full"/>
      }
    </ysh-panel>

    <ysh-panel
      class="grid__panel"
      heading="Images"
      infotip="Tap image for details"
      padding="all-sides"
      [loading]="!order">

      @if (orderPhotos) {
        <ysh-gallery [images]="orderPhotos"/>
      }
    </ysh-panel>
  </div>
</div>
